import React from "react"
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from "@/components/ui/resizable"
import { Toolbar } from "@/components/Layout/Toolbar"
import { FilePanel } from "@/components/FilePanel/FilePanel"
import { LogPanel } from "@/components/LogPanel/LogPanel"
import { BatchRenameDialog } from "@/components/Rename/BatchRenameDialog"

export function FileManagerPage() {
  const [isRenameOpen, setIsRenameOpen] = React.useState(false)

  return (
    <>
      <Toolbar onRenameClick={() => setIsRenameOpen(true)} />

      <ResizablePanelGroup orientation="vertical" className="flex-1 min-h-0">
        <ResizablePanel defaultSize="70%" minSize="30%">
          <ResizablePanelGroup orientation="horizontal">
            <ResizablePanel defaultSize="50%" minSize="20%">
              <FilePanel side="left" />
            </ResizablePanel>
            <ResizableHandle orientation="horizontal" withHandle />
            <ResizablePanel defaultSize="50%" minSize="20%">
              <FilePanel side="right" />
            </ResizablePanel>
          </ResizablePanelGroup>
        </ResizablePanel>

        <ResizableHandle orientation="vertical" withHandle />

        <ResizablePanel defaultSize="30%" minSize="10%" maxSize="70%">
          <LogPanel />
        </ResizablePanel>
      </ResizablePanelGroup>

      <BatchRenameDialog open={isRenameOpen} onOpenChange={setIsRenameOpen} />
    </>
  )
}
